module.exports = __webpack_public_path__ + "static/media/blogPostFour.40df3101.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/blogPostFour.png
// module id = 42
// module chunks = 0